module.exports = __webpack_public_path__ + "img/gh-12132____-2321.prt.4afbd9f0.jpg";